'use client'

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from '@/components/ui/dialog'
import Image from 'next/image'
import { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface MediaDialogProps extends PropsWithChildren {
  src: string
  triggerClassName?: string
}

const MediaDialog = ({ children, src, triggerClassName }: MediaDialogProps) => {
  return (
    <Dialog>
      {/* No `asChild`: DialogTrigger renders its own <button> and the
          children go inside it. Using asChild here made Radix's Slot clone
          a server-rendered child on the client only, which caused an
          unavoidable (suppressHydrationWarning-proof, because structural)
          hydration mismatch under React 19 + RSC. */}
      <DialogTrigger
        className={cn(
          'cursor-pointer border-0 bg-transparent p-0',
          triggerClassName,
        )}
      >
        {children}
      </DialogTrigger>

      <DialogContent aria-describedby={undefined} className="max-w-none bg-transparent p-0">
        <DialogTitle className="sr-only">Media player</DialogTitle>
        <div className="relative flex h-lvh w-lvw items-center justify-center">
          <div className="flex h-full w-full items-center justify-center overflow-hidden">
            <video
              controls
              className="h-full max-h-dvh w-full object-cover sm:object-contain"
              autoPlay
              playsInline
            >
              <source src={src} type="video/mp4" />
            </video>
          </div>

          <div className="absolute left-0 top-0 flex w-full justify-end bg-gradient-to-b from-black to-transparent px-7.5 py-8 md:px-25 md:py-13.5">
            <DialogClose>
              <Image
                priority
                src={'/icons/white-close.svg'}
                height={32}
                width={32}
                alt={'/icons/white-close.svg'}
                className="size-6 sm:size-8"
              />
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default MediaDialog
